import React from "react";

import Folder from "entities/Folder";
import { useParams } from "react-router";
import { FOLDER_EXTRA_DATA } from "utils/constants";

import View from "./View";

const Component = () => {
  const { id, action } = useParams();
  return (
    <Folder
      View={View}
      folderNum={id}
      action={action}
      filter={{
        where: { folderNum: id, extraData: FOLDER_EXTRA_DATA.WORKFLOW },
      }}
    />
  );
};

export default Component;
